import config from 'config';

export const StockStatus = {
  OK: 'OK',
  LOW_STOCK: 'LOW_STOCK',
  CRITICAL: 'CRITICAL',
  SOLD_OUT: 'SOLD_OUT',
  URGENT: 'URGENT',
  BOPS_UNAVAILABLE: 'BOPS_UNAVAILABLE',
};

export const lowStockStatuses = [
  StockStatus.URGENT,
  StockStatus.CRITICAL,
  StockStatus.LOW_STOCK,
];

export default function getStockStatus({ availableQuantity, region }) {
  const locationLowStockConfig = config.get(
    'public.quantityRules.locationLowStockIndicator.product'
  );
  const lowStockConfig =
    locationLowStockConfig[region] || locationLowStockConfig.NA;

  if (availableQuantity <= 0) {
    return StockStatus.SOLD_OUT;
  }
  if (lowStockConfig.urgent && availableQuantity <= lowStockConfig.urgent) {
    return StockStatus.URGENT;
  }
  if (
    lowStockConfig.criticalStockMax &&
    availableQuantity <= lowStockConfig.criticalStockMax
  ) {
    return StockStatus.CRITICAL;
  }
  if (
    lowStockConfig.lowStockMax &&
    availableQuantity <= lowStockConfig.lowStockMax
  ) {
    return StockStatus.LOW_STOCK;
  }
  return StockStatus.OK;
}
